import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const CategoryMaster = () => {
  const [type, setType] = useState("");
  const [team, setTeam] = useState("");
  const [rowData, setRowData] = useState([]);
  const [errors, setErrors] = useState({ type: "", team: "" });
  const [editingCategory, setEditingCategory] = useState(null);
  const [alert, setAlert] = useState({ message: "", type: "" });


  useEffect(() => {
    // Fetch initial data
    axios.get(`${API_BASE_URL}/category`)
      .then((response) => {
        setRowData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);



    useEffect(() => {
          document.title = 'Category Master - Calendar Services';
        }, []);


        useEffect(() => {
          if (alert.message) {
            const timer = setTimeout(() => setAlert({ message: "", type: "" }), 3000);
            return () => clearTimeout(timer);
          }
        }, [alert]);

        


  const columnDefs = [
    { headerName: "S.No", valueGetter: (params) => params.node.rowIndex + 1 },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <div className="flex space-x-2">
          <button
            className="text-blue-500 hover:underline"
            onClick={() => handleEdit(params.data)}
          >
            Edit
          </button>
          <button
            className="text-red-500 hover:underline"
            onClick={() => handleDelete(params.data.id)}
          >
            Delete
          </button>
        </div>
      ),
    },
    { headerName: "Category Name", field: "category" ,filter: true},
    { headerName: "Type", field: "type",filter: true },
  ];

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    if (!type) {
      newErrors.type = "Type is required";
      isValid = false;
    }
    if (!team) {
      newErrors.team = "Category Name is required";
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleSave = () => {
    const loggedInUser = localStorage.getItem("username");

    if (validateForm()) {
      const categoryData = { type, category: team };

      if (editingCategory) {
        categoryData.mby = loggedInUser;
        axios.put(`${API_BASE_URL}/category/${editingCategory.id}`, categoryData)
          .then((response) => {
            setRowData((prevData) =>
              prevData.map((row) =>
                row.id === editingCategory.id ? { ...response.data } : row
              )
            );
            setAlert({ message: "Category updated successfully", type: "success" });
            resetForm();
          })
          .catch((error) => {
            setAlert({
              message: error.response?.data?.message || "Error updating category",
              type: "error",
            });
          });
      } else {
        categoryData.cby = loggedInUser;
        axios
          // .post("http://localhost:3036/category", categoryData)
          .post(`${API_BASE_URL}/category`, categoryData)
          // .post("https://calendarservicesapi.nithra.mobi/category", categoryData)
          .then((response) => {
            setRowData((prevData) => [...prevData, response.data]);
            setAlert({ message: "Category added successfully", type: "success" });
            resetForm();
          })
          .catch((error) => {
            setAlert({
              message: error.response?.data?.message || "Error adding category",
              type: "error",
            });
          });
      }
    }
  };

  useEffect(() => {
    if (alert.message) {
      const timer = setTimeout(() => setAlert({ message: "", type: "" }), 3000);
      return () => clearTimeout(timer);
    }
  }, [alert]);

  const handleEdit = (data) => {
    setEditingCategory(data);
    setType(data.type);
    setTeam(data.category);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };


  
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      axios
        .delete(`https://calendarservicesapi.nithra.mobi/category/${id}`)
        .then(() => {
          setRowData((prevData) => prevData.filter((row) => row.id !== id));
          setAlert({ message: "Category deleted successfully", type: "success" });
        })
        .catch((error) => {
          setAlert({
            message: error.response?.data?.message || "Error deleting category",
            type: "error",
          });
        });
    }
  };

  const resetForm = () => {
    setType("");
    setTeam("");
    setEditingCategory(null);
    setErrors({});
  };

  return (
    <div className="bg-gray-100 p-6">
      <div className="max-w-xl mx-auto mt-8 bg-white shadow-md rounded mb-6 p-7">
        
        <h2 className="text-lg font-bold text-blue-600 mb-4">
          {editingCategory ? "Edit Category" : "Add Category"}
        </h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm text-gray-700">Select Type<span className="text-red-500">*</span></label>
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="w-full p-2 border rounded"
            >
              <option value="">Select Type</option>
              <option value="ஜோதிடர்">ஜோதிடர்</option>
              <option value="ஐயர்">ஐயர்</option>
              <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
              <option value="எண்கணிதம்">எண்கணிதம்</option>
              <option value="Other">மற்றவை</option>
            </select>
            {errors.type && <p className="text-red-500 text-sm">{errors.type}</p>}
          </div>
          <div>
            <label className="block text-sm text-gray-700">Category Name<span className="text-red-500">*</span></label>
            <input
              type="text"
              value={team}
              onChange={(e) => setTeam(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter category name"
            />
            {errors.team && <p className="text-red-500 text-sm">{errors.team}</p>}
          </div>
          <div className="text-right">
            <button
              onClick={handleSave}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              {editingCategory ? "Update" : "Save"}
            </button>
          </div>
        </div>
        {alert.message && (
  <div className={`fixed top-20 right-4 px-5 py-3 text-white rounded-lg shadow-lg transition-all duration-300 z-50 ${alert.type === 'success' ? 'bg-green-500' : 'bg-red-500'}`}>
    <span>{alert.message}</span>
  </div>
)}

      </div>

      <div className="max-w-5xl mx-auto mt-9 bg-white shadow-md rounded mb-10">
        <div className="p-9">
          <h2 className="text-lg font-bold text-blue-600 mb-4">View Categories</h2>
          <div
            className="ag-theme-alpine"
            style={{ height: 500, width: "100%", padding: "0 24px" }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              defaultColDef={{ sortable: true, filter: true, editable:true }}
              pagination={true}
              paginationPageSize={10}
              
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryMaster;





